import React, { useMemo, useState } from 'react';
import { MoonLoader } from 'react-spinners';
import '../../../../styles/ScheduleTable.css';
import '../../../../styles/Modal.css';
import { useSport } from '../../../../context/SportContext.tsx';
import { TeaserGames } from './TeaserGames.tsx';
import AlertError from '../../../alerts/AlertError.tsx';
import { Schedule } from '../../../../models/Schedule.tsx';
import { TableComponents } from './TableComponents.tsx';
import { buildLeagueSections, ScheduleDateHeader } from '../../../../helpers/scheduleStickyHeaders.tsx';
import { useIsSmallScreen } from '../../SportsSchedule.tsx';

function TeaserComponents() {
    const { activeGamesTeaser, loading, noDataTeaser, selectedGamesTeaser, showLimitAlert: showLeagueAlert } = useSport();
    const isSmallScreen = useIsSmallScreen();
    const [showLimitAlert, setShowLimitAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const nonLiveGames = useMemo(
        () => activeGamesTeaser.filter((game: Schedule) => game.status === 'unplayed' && !game.is_live),
        [activeGamesTeaser]
    );

    const leagueSections = useMemo(
        () => buildLeagueSections(nonLiveGames),
        [nonLiveGames]
    );

    return (
        <>
            {loading && !isSmallScreen && (
                <div className="loading-overlay-schedule">
                    <MoonLoader color="#b6cc18" loading={loading} size={55} />
                </div>
            )}
            {selectedGamesTeaser && (
                <>
                    {nonLiveGames.length > 0 ? (
                        <div className="containertable">
                            {leagueSections.map(league => {
                                const firstGame = league.dates[0].games[0];
                                return (
                                    <div className="schedule-league-section" key={league.leagueKey}>
                                        <TableComponents
                                            game={firstGame}
                                            showColumnHeaders={false}
                                        />
                                        <div className="schedule-sticky-columns">
                                            <TableComponents
                                                game={firstGame}
                                                showLeagueBanner={false}
                                            />
                                        </div>
                                        {league.dates.map(dateSection => (
                                            <div
                                                className="schedule-date-section"
                                                key={`${league.leagueKey}-${dateSection.dateKey}`}
                                            >
                                                <ScheduleDateHeader startDate={dateSection.games[0].start_date} />
                                                {dateSection.games.map(game => (
                                                    <TeaserGames
                                                        key={game.id ?? `${game.leagueKey}-${game.game_id}`}
                                                        game={game}
                                                        setShowLimitAlert={setShowLimitAlert}
                                                        showHeaderByLeague={false}
                                                        showHeaderByDate={false}
                                                        setErrorMessage={setErrorMessage}
                                                    />
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        !showLeagueAlert && noDataTeaser && (
                            <div className="no-data-games">
                                There are currently no games available for this league.
                            </div>
                        )
                    )}
                </>
            )}

            {showLimitAlert && (
                <AlertError
                    message={errorMessage}
                    onClose={() => setShowLimitAlert(false)}
                />
            )}
            {errorMessage && (
                <AlertError
                    message={errorMessage}
                    onClose={() => setErrorMessage('')}
                />
            )}
        </>
    );
}

export default TeaserComponents;
